import { Column, Table } from '@tanstack/react-table'
import clsx from 'clsx'
import { Button } from '@/ui/Button'
import { Popup } from '@/ui/Popup'
import commonStyles from './Common.module.scss'
import styles from './LockHeader.module.scss'
import ArrowDownIcon from '../../assets/arrow-down.svg'
import { Log } from '@/types/logs'
import LockIcon from '../../../../modules/CombinedLogs/assets/lock.svg'
import UnlockIcon from '../../../../modules/CombinedLogs/assets/unlock.svg'
import { useLockControllerLog } from '@/modules/CombinedLogs/api/useLockControllerLog'
import { useMemo } from 'react'
import { checkIsLogUnfinished } from '@/modules/CombinedLogs/helpers/checkIsLogUnfinished'

export const LockHeader = ({ table, column }: { table: Table<Log>; column: Column<Log> }) => {
    const { handleLockControllerLog } = useLockControllerLog()
    const isAllLocked = table.getFilteredRowModel().rows.every((row) => row.original.isLocked)
    const state = table.getState()

    const isActive = useMemo(
        () =>
            state.sorting.find((item) => item.id === column.id) ||
            state.columnFilters.find((item) => item.id === column.id),
        [state]
    )

    const handleLockAllRecords = () => {
        const recordsToLock = table
            .getFilteredRowModel()
            .rows.filter((row) => !row.original.isLocked)
            .filter(
                (row) =>
                    row.original.codingPeriodInfo.permissions.includes('Lock') ||
                    row.original.codingPeriodInfo.permissions.includes('Unlock')
            )
            .filter((row) => !checkIsLogUnfinished(row.original))
            .map((row) => ({
                id: row.original.id,
                isLocked: true,
            }))

        handleLockControllerLog(recordsToLock)
    }

    const handleSortByUnlocked = () => {
        column.toggleSorting(false)
    }

    return (
        <Popup
            triggerComponent={(open: boolean) => (
                <Button
                    size="small"
                    variant="transparent"
                    className={clsx(commonStyles.trigger, styles.trigger, { [commonStyles.active]: open || isActive })}
                >
                    {isAllLocked ? <LockIcon /> : <UnlockIcon />}
                    <ArrowDownIcon />
                </Button>
            )}
            attachToTrigger
            placement="bottom-start"
            className={commonStyles.popup}
        >
            <div className={styles.container}>
                <div className={styles.actionWrapper}>
                    <Button onClick={handleSortByUnlocked} variant="transparent" size="small" className={styles.action}>
                        Sort by unlocked
                    </Button>
                </div>
                <div className={styles.actionWrapper}>
                    <Button onClick={handleLockAllRecords} variant="transparent" size="small" className={styles.action}>
                        Lock all records
                    </Button>
                </div>
            </div>
        </Popup>
    )
}
